import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "circles-2-overlapping-diagonal-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 19 19", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", stroke: "currentColor" },
        React.createElement("path", { strokeLinecap: "round", d: "M14.182 11.182a4.502 4.502 0 1 0-7.49-4.485 4.5 4.5 0 0 0 5.623 5.608" }),
        React.createElement("path", { strokeLinecap: "round", d: "M4.818 7.818a4.5 4.5 0 1 0 6.364 0" }),
        React.createElement("path", { d: "M12.5 11c0 .448-.065.887-.193 1.307a4.5 4.5 0 0 1-5.613-5.614A4.5 4.5 0 0 1 12.5 11Z" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
